/**
 * Settings.jsx — DEPRECATED (issue #267).
 *
 * The standalone Settings widget has been consolidated into the
 * hamburger menu's Settings tab (see SettingsHome.jsx). The catalog
 * entry is hidden so users can no longer add a new instance, but this
 * renderer is retained so existing saved layouts that still reference
 * `widget_type: 'settings'` keep loading.
 *
 * The widget now shows a simple redirect: a button that opens the
 * hamburger menu on the Settings tab. A follow-up PR can delete this
 * file (and the Settings.css import in widgets/index.jsx) once enough
 * time has passed for active dashboards to migrate naturally.
 *
 * CSP-clean: Solid event handlers compile to addEventListener.
 */
import { homeMenu } from '../lib/homeMenuStore.js';
import { EMOJI } from '../lib/emoji.js';

export default function Settings() {
  function openHamburger() {
    homeMenu.openWith('settings');
  }

  return (
    <div class="v2-widget v2-settings">
      <div class="v2-empty" style={{ 'text-align': 'center', padding: 'var(--sp-3)' }}>
        <h3 style={{ margin: '0 0 var(--sp-2)' }}>
          {EMOJI.settings} Settings have moved
        </h3>
        <p class="v2-settings__hint" style={{ 'max-width': '36em', margin: '0 auto var(--sp-3)' }}>
          {EMOJI.info} Profile, privacy, API keys and Fissal memories
          now live in the hamburger menu so there is a single settings
          surface for the whole dashboard. Per-widget options stay on
          each widget's <span style={{ 'white-space': 'nowrap' }}>{EMOJI.settings} gear icon</span>.
        </p>
        <button type="button" class="btn btn-primary" onClick={openHamburger}>
          {EMOJI.menu} Open Settings in the hamburger menu
        </button>
        <p class="v2-settings__hint" style={{ 'margin-top': 'var(--sp-3)', 'font-size': 'var(--fs-xs)' }}>
          You can safely close this window — the launcher no longer
          offers it as an addable widget.
        </p>
      </div>
    </div>
  );
}
